// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'
// import LogRocket from 'logrocket'

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN
const ENVIRONMENT =
  process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV || process.env.NODE_ENV

Sentry.init({
  dsn: SENTRY_DSN,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,
  environment: ENVIRONMENT,
  integrations: [
    new Sentry.BrowserTracing({
      tracingOrigins: ['api.testnet.nf.domains', 'api.nf.domains']
    })
  ],
  beforeSend(event) {
    if (event.exception) {
      Sentry.showReportDialog({
        eventId: event.event_id,
        user: {
          email: 'feedback@txnlab.dev',
          name: 'anon'
        },
        title: 'Oops! Something broke.',
        subtitle:
          "This is why we can't have nice things. Please let us know what happened so we can fix it."
      })
    }

    // const logRocketSession = LogRocket.sessionURL
    // if (logRocketSession !== null) {
    //   event.extra = {
    //     ...event.extra,
    //     ['LogRocket Timestamp']: logRocketSession
    //   }
    //   return event
    // } else {
    //   return event
    // }

    return event
  },
  ignoreErrors: [
    'Operation cancelled',
    'Abort route change. Please ignore this error.',
    'Insufficient balance',
    'Invalid Input: Invalid Asset',
    'this name/nfd already has a verify request outstanding',
    'Can not open popup window',
    'Insufficient balance',
    'User did not accept terms',
    'The bridge server is not active anymore'
  ]
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
})
